import "./styles.css";
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import { TopHeadErrorIcon } from "../icons/TopHeadErrorIcon";

export const TopHeadValidate = ({
  onBack = () => {},
  onContinue = () => {},
  onError = () => {},
  validateTopHeadImage = () => ({ ok: true, isHeadDetected: true }),
}) => {
  const { t } = useTranslation("scanModule");
  const [data, setData] = useState({
    fetchComplete: false,
    isHeadDetected: false,
  });

  useEffect(() => {
    validateTopHeadImage().then((response) => {
      if (response.ok) {
        if (response.isHeadDetected) {
          onContinue();
        } else {
          setData((prevValue) => ({
            ...prevValue,
            fetchComplete: true,
            isHeadDetected: response.isHeadDetected,
          }));
        }
      } else {
        onError();
      }
    });
  }, [onContinue, onError, validateTopHeadImage]);

  return (
    <>
      {data.fetchComplete ? (
        <>
          <div className="top-head-info-container">
            <TopHeadErrorIcon className="top-head-error-icon" />
            <h2 className="top-head-info-heading">
              {t("top-head-validate-title")}
            </h2>
            <p>{t("top-head-validate-description-1")}</p>
            <p>{t("top-head-validate-description-2")}</p>
          </div>
          <div className="top-head-info-buttons">
            <Button
              text={t("retake-top-head-picture")}
              onClick={() => onBack()}
              alternateColor={true}
              usePrimaryColor={false}
            />
            <Button
              text={t("continue-top-head-image")}
              onClick={() => onContinue()}
              alternateColor={true}
            />
          </div>
        </>
      ) : (
        <div className="scan-module-loading">
          <CircularProgress
            disableShrink
            color="inherit"
            size={40}
            thickness={4}
          />
          <p className="scan-interim-text">{t("validating-top-head-image")}</p>
        </div>
      )}
    </>
  );
};
